<template>
    <div class="row">
    <RwvMenu />
    </div>
</template>

<script>
import UserInfoStore from '../app/user-info-store';
import RwvMenu from "@/components/TheMenu";

export default {
    name: 'Home',
    components: {
      RwvMenu,
    },
    async created() {
//    console.log("Home")
      // display user stored user state on console
//      var usrState = 'User Group: ' + UserInfoStore.state.userGroup +
//        ' === ' + 'Branch Name: ' + UserInfoStore.state.branchName +
//        '=== ' + 'User Email: ' + UserInfoStore.state.userEmail;
//      console.log("User State => ", usrState);
    },
    data: function() {
        return{
            userPoolId: process.env.VUE_APP_COGNITO_USERPOOL_ID,
            userInfo: UserInfoStore.state.cognitoInfo,
            branchName: UserInfoStore.state.branchName,
            userGroup: UserInfoStore.state.userGroup
        }
    }
}
</script>

<style>

</style>
